export default __webpack_public_path__ + "static/media/shrutiA.f3fef268.wav";